define([
    'text!product-detail2024/page/furniture-page-content.html',
    'product-detail2024/furniture/knowledge-info-new',
    'product-detail2024/component/more-products',
    'product-detail2024/component/next-product',
    'product-detail2024/furniture/maintain-info',
    'product-detail2024/component/scene-list-new',
    'product-detail2024/component/sku-info-new',
    'product-detail2024/component/spec-info-new',
    'product-detail2024/furniture/design-info-new',
    'product-detail2024/furniture/material-list-new',
    'product-detail2024/component/dimension-table',
    'product-detail2024/component/feature-list'

    // 'product-detail/furniture/knowledge-info',
    // 'product-detail/component/more-products',
    // 'product-detail/component/next-product',
    // 'product-detail/furniture/maintain-info',
    // 'product-detail/component/scene-list',
    // 'product-detail/component/sku-info',
    // 'product-detail/component/spec-info',
    // 'product-detail/furniture/design-info',
    // 'product-detail/furniture/material-list',
    // 'product-detail/component/dimension-table',
    // 'product-detail/component/feature-list'
], function(
    tpl,
    KnowledgeInfo,
    MoreProducts,
    NextProduct,
    MaintainInfo,
    SceneList,
    SkuInfo,
    SpecInfo,
    DesignInfo,
    MaterialList,
    DimensionTable,
    FeatureList
){
    return {
        template: tpl,
        components: {
            KnowledgeInfo: KnowledgeInfo,
            MoreProducts: MoreProducts,
            NextProduct: NextProduct,
            MaintainInfo: MaintainInfo,
            SceneList: SceneList,
            SkuInfo: SkuInfo,
            SpecInfo: SpecInfo,
            DesignInfo: DesignInfo,
            MaterialList: MaterialList,
            DimensionTable: DimensionTable,
            FeatureList: FeatureList
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./product-detail2024/page/furniture-page-content.js
// module id = 195
// module chunks = 0